import api from "../../api"
import {

    CHAT_USERS_REQUEST,
    CHAT_USERS_SUCCESS,
    CHAT_USERS_FAIL,



    SEND_PRIVATE_MESSAGE_REQUEST,
    SEND_PRIVATE_MESSAGE_SUCCESS,
    SEND_PRIVATE_MESSAGE_FAIL,

    GET_PRIVATE_CONVERSATIONS_REQUEST,
    GET_PRIVATE_CONVERSATIONS_SUCCESS,
    GET_PRIVATE_CONVERSATIONS_FAIL,



    SINGLE_CONVERSATION_REQUEST,
    SINGLE_CONVERSATION_SUCCESS,
    SINGLE_CONVERSATION_FAIL,

    CLEAR_CONVERSATION_REQUEST,
    CLEAR_CONVERSATION_SUCCESS,
    CLEAR_CONVERSATION_AIL,


} from "../constants/chatConstants"

export const getChatUsersAction = (queryParams = {}) => async (dispatch) => {
    try {
        dispatch({ type: CHAT_USERS_REQUEST })

        const queryString = new URLSearchParams(queryParams).toString();
        const url = queryString ? `/api/v1/get-chat-users?${queryString}` : `/api/v1/get-chat-users`;

        const { data } = await api.get(url);
        dispatch({
            type: CHAT_USERS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: CHAT_USERS_FAIL,
            payload: error.response.data.message,
        })
    }
}

export const sendPrivateMessageAction = (messageData) => async (dispatch) => {
    try {
        dispatch({ type: SEND_PRIVATE_MESSAGE_REQUEST });


        const { data } = await api.post(`/api/v1/create-or-send-message`, messageData);

        dispatch({
            type: SEND_PRIVATE_MESSAGE_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: SEND_PRIVATE_MESSAGE_FAIL,
            payload: error.response.data.message,
        });
    }
};



export const getPrivateConversationsAction = (queryParams = {}) => async (dispatch) => {
    try {
        dispatch({ type: GET_PRIVATE_CONVERSATIONS_REQUEST })

        const queryString = new URLSearchParams(queryParams).toString();
        const url = queryString ? `/api/v1/get-private-conversations?${queryString}` : `/api/v1/get-private-conversations`;

        const { data } = await api.get(url);
        dispatch({
            type: GET_PRIVATE_CONVERSATIONS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: GET_PRIVATE_CONVERSATIONS_FAIL,
            payload: error.response.data.message,
        })
    }
}


export const singleConversationsAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: SINGLE_CONVERSATION_REQUEST })

        const { data } = await api.get(`/api/v1/get-single-conversation?conversation_id=${id}`)
        dispatch({
            type: SINGLE_CONVERSATION_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: SINGLE_CONVERSATION_FAIL,
            payload: error.response.data.message,
        })
    }
}


export const clearConversationAction = (messageData) => async (dispatch) => {
    try {
        dispatch({ type: CLEAR_CONVERSATION_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.put(`/api/v1/clear-conversation`, messageData, config)
        dispatch({
            type: CLEAR_CONVERSATION_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: CLEAR_CONVERSATION_AIL,
            payload: error.response.data.message,
        })
    }
}


